import { combineEpics } from 'redux-observable';
import { createTrackEpic } from './create-track';
import { createTracksAfterReleaseEpic } from './create-tracks-after-release';
import { getTracksEpic } from './get-tracks';
import { removeTrackEpic } from './remove-track';
import { autosaveEpic } from './autosave';
import { updateTrackEpic } from './update-track';
import { createTracksAfterAssetEpic } from './create-tracks-after-asset';
import { updateTracksOrderEpic } from './update-tracks-order';
import { orderAfterRemoveEpic } from './order-after-remove';
import { updateTrackTitleEpic } from './update-track-title';
import { newTracksAfterAssetEpic } from './new-track-for-asset';
import { listMultipleTracksAfterReleasesEpic } from './list-multiple-tracks-after-releases';
import { listMultipleTracksEpic } from './list-multiple-tracks';
import { removeTrackAfteAssetEpic } from './remove-track-on-asset-delete';
import { getTracksAfterACRValidationEpic } from './get-track-after-acr-validation';
import { notifyInvalidTrackEpic } from './notify-invalid-tracks';
import { updateTrackLanguagePresetsEpic } from './update-track-language-presets';

const tracksEpic = combineEpics(
  autosaveEpic,
  getTracksEpic,
  createTrackEpic,
  createTracksAfterReleaseEpic,
  createTracksAfterAssetEpic,
  updateTrackEpic,
  updateTracksOrderEpic,
  removeTrackEpic,
  orderAfterRemoveEpic,
  updateTrackTitleEpic,
  newTracksAfterAssetEpic,
  listMultipleTracksAfterReleasesEpic,
  listMultipleTracksEpic,
  removeTrackAfteAssetEpic,
  getTracksAfterACRValidationEpic,
  notifyInvalidTrackEpic,
  updateTrackLanguagePresetsEpic
);

export default tracksEpic;